var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container"},[_c('div',{staticClass:"box"},[(_vm.checked)?_c('i',{staticClass:"check fa fa-check"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }